import { Typography, Box } from '@mui/material';
import React, { useContext, useState, useEffect } from 'react';
import Content from '../components/Layout/Content';
import ReusableTable from '../components/ReusableTable/ReusableTable';
import FilterDropDown from '../components/filterDropDown/FilterDropDown';
import SearchBar from '../components/SearchBar/Search';
import NotFound from '../components/NotFound/NotFoundPage';
import PaginationComponent from '../components/paginationComponent/ServerSidePaginationComponent';
import {
  handleTimeFilter,
  handleStatusFilter,
  searchDataByKey,
  visitsArrayConvertor,
  getIconFromSubItemsArray,
  formatDateInMMDDYYYYWithComma,
  getJsonInfoFromReference,
  extractValueFromRefDisplayJson,
  handleVisitTypeFilter,
  calculateDateFilterTimeStamp,
  getStatusFilterParamList,
} from '../shared/helper';
import {
  visitsStatusFilterDatas,
  dateFilterMenuItems,
  NUMBER_OF_ROWS_PER_PAGE,
  VISIT_STATUS_LIST,
} from '../shared/constants';
import { VISIT_TYPES, DEFAULT_NULL_REPLACEMENT } from '../shared/constants';
import { BreadcrumbComponent } from '../components/BreadcrumbComponent/BreadcrumbComponent';
import { useSnackbar } from 'notistack';
import { useLazyQuery } from '@apollo/client';
import {
  FETCH_ALL_VISITS_QUERY,
  FETCH_VISIT_DETAILS_BY_ID_QUERY,
} from '../services/VisitsQueries/VisitsService';
import { SimpleBackdrop } from '../components/SimpleBackdropComponent/SimpleBackdrop';
import { ServiceFlyout } from '../components/ServiceFlyout/ServiceFlyout';
import ApplicationContext from '../context/applicationContext';
import {
  VISIT,
  VISIT_TABLE_HEADING as tableHeading,
  VISIT_BREADCRUMBDATA as breadcrumbData,
} from '../shared/Strings';

const boxContainer = {
  position: 'relative',
  display: 'flex',
  flexWrap: 'wrap',
  top: 40,
  flex: 1,
};

const table = {
  marginTop: 8,
  '& .css-1kn3lhz': {},
};

export const Visits = props => {
  const [searchValue, setSearchValue] = useState('');
  const [recordsData, setRecordedData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [timeFilter, setTimeFilter] = useState('all');
  const [statusFilter, setStatusFilter] = useState('all');
  const [visitType, setVisitType] = useState('all visits');
  const [openFlyout, setOpenFlyout] = useState(false);
  const { menuItems } = useContext(ApplicationContext);
  const [detailsData, setDetailsData] = useState([]);
  const [modalTitle, setModalTitle] = useState('');
  const [selectedTableId, setSelectedTableId] = useState(null);
  const [totalCount, setTotalCount] = useState();
  const [offset, setOffset] = useState(0);

  const { enqueueSnackbar } = useSnackbar();

  // //data coming
  // const allVisits = useQuery(FETCH_ALL_VISITS_QUERY, {
  //   variables: {
  //     visitType: 'ALL',
  //     sourceUrl: '',
  //     count: '10',
  //     offset: 0,
  //     dateFilter: 0,
  //     statusFilter: '',
  //     searchFilter: '',
  //   },
  // });

  const [fetchAllVisits, fetchAllVisitsCall] = useLazyQuery(
    FETCH_ALL_VISITS_QUERY,
    {
      fetchPolicy: 'cache-and-network',
      onError: err => {
        enqueueSnackbar(VISIT.ON_ERROR_TEXT.WENT_WRONG_TEXT, {
          variant: 'error',
        });
      },
      onCompleted: res => {
        let result = res.fetchAllVisits.visitsList;
        let convertor = JSON.parse(result);
        let data = visitsArrayConvertor(convertor);
        setRecordedData(data);
        setFilteredData(data);
        setTotalCount(res.fetchAllVisits.count);
      },
    }
  );

  const [fetchVisitById, fetchVisitByIdCall] = useLazyQuery(
    FETCH_VISIT_DETAILS_BY_ID_QUERY,
    {
      fetchPolicy: 'cache-and-network',
      onError: err => {
        enqueueSnackbar(VISIT.ON_ERROR_TEXT.BY_ID, {
          variant: 'error',
        });
      },
      onCompleted: res => {
        //show data
        showFlyout(res.fetchVisitById);
      },
    }
  );

  useEffect(() => {
    fetchAllVisits({
      variables: {
        visitType: 'ALL',
        sourceUrl: '',
        count: NUMBER_OF_ROWS_PER_PAGE.toString(),
        offset: offset,
        dateFilter: calculateDateFilterTimeStamp(timeFilter) || 0,
        statusFilter: getStatusFilterParamList(
          statusFilter,
          visitsStatusFilterDatas,
          VISIT_STATUS_LIST
        ),
        searchFilter: searchValue,
      },
    });
  }, [offset, searchValue, timeFilter, statusFilter, visitType, fetchAllVisits]);

  // useEffect(() => {
  //   fetchAllVisits({
  //     variables: {
  //       visitType: 'ALL',
  //       sourceUrl: '',
  //       count: NUMBER_OF_ROWS_PER_PAGE.toString(),
  //       offset: offset,
  //       dateFilter: calculateDateFilterTimeStamp(timeFilter) || 0,
  //       statusFilter: '',
  //       searchFilter: '',
  //     },
  //   });
  // }, [offset]);

  const handleChangeFilter = () => {
    setOffset(0);
  };

  const onPageClick = pageNumber => {
    setOffset((pageNumber - 1) * 10);
  };

  const closeFlyout = () => {
    setOpenFlyout(false);
  };

  const onSearch = text => {
    setSearchValue(text);
  };

  const dateFilterOptions = {
    options: dateFilterMenuItems,
    value: timeFilter,
    changeHandler: ev => {
      setTimeFilter(ev.target.value);
      handleChangeFilter()
    },
  };

  const visitTypeFilterOptions = {
    options: VISIT_TYPES,
    value: visitType,
    changeHandler: ev => {
      setVisitType(ev.target.value);
      handleChangeFilter();
    },
  };

  const statusFilterOptions = {
    options: visitsStatusFilterDatas,
    value: statusFilter,
    changeHandler: ev => {
      setStatusFilter(ev.target.value);
      handleChangeFilter()
    },
  };

  const detailsLoading = fetchVisitByIdCall.loading;

  // useEffect(() => {
  //   const timeFilteredData = handleTimeFilter(
  //     timeFilter,
  //     recordsData,
  //     'recordedOn'
  //   );
  //   const visitTypeFilteredData = handleVisitTypeFilter(
  //     visitType,
  //     'typeOfVisitValue',
  //     timeFilteredData
  //   );
  //   const statusFilteredData = handleStatusFilter(
  //     statusFilter,
  //     visitTypeFilteredData,
  //     visitsStatusFilterDatas
  //   );
  //   const searchData = searchDataByKey(
  //     statusFilteredData,
  //     'facility',
  //     searchValue
  //   );
  //   setFilteredData(searchData);
  // }, [timeFilter, visitType, statusFilter, searchValue, recordsData]);

  const showFlyout = result => {
    const parseResult = JSON.parse(result?.encounter);
    const tableRowInfo = recordsData.find(obj => obj.id === selectedTableId);
    const modalData = [
      {
        column_name: VISIT.MODAL_DATA.STATUS,
        value: tableRowInfo.status || DEFAULT_NULL_REPLACEMENT,
      },
      {
        column_name: VISIT.MODAL_DATA.RECORDED_ON,
        value: tableRowInfo.recordedOn || DEFAULT_NULL_REPLACEMENT,
        width: 6,
      },
      {
        column_name: VISIT.MODAL_DATA.RECORDED_BY,
        value: tableRowInfo.facility || DEFAULT_NULL_REPLACEMENT,
      },
      {
        column_name: VISIT.MODAL_DATA.VISIT_TYPE,
        value: tableRowInfo.typeOfVisitValue || DEFAULT_NULL_REPLACEMENT,
      },
      {
        column_name: VISIT.MODAL_DATA.PROVIDER,
        value:
          (parseResult.participant &&
            parseResult.participant.length &&
            parseResult.participant[0].individual &&
            parseResult.participant[0].individual.display &&
            extractValueFromRefDisplayJson(
              getJsonInfoFromReference(
                parseResult?.participant[0]?.individual?.display
              ),
              'provider'
            )) ||
          DEFAULT_NULL_REPLACEMENT,
      },
      {
        column_name: VISIT.MODAL_DATA.LAST_VISITED,
        value:
          (parseResult.period &&
            parseResult.period.start &&
            formatDateInMMDDYYYYWithComma(parseResult.period.start)) ||
          DEFAULT_NULL_REPLACEMENT,
      },
      {
        column_name: VISIT.MODAL_DATA.PROVIDER_SPECIALITY,
        value:
          (parseResult.participant &&
            parseResult.participant.length &&
            parseResult.participant[0].individual &&
            parseResult.participant[0].individual.display &&
            extractValueFromRefDisplayJson(
              getJsonInfoFromReference(
                parseResult?.participant[0]?.individual?.display
              ),
              'speciality'
            )) ||
          DEFAULT_NULL_REPLACEMENT,
      },
      {
        column_name: VISIT.MODAL_DATA.SERVICE_TYPE,
        value:
          (parseResult.serviceType && parseResult.serviceType.text) ||
          DEFAULT_NULL_REPLACEMENT,
      },
      {
        column_name: VISIT.MODAL_DATA.DOCUMENTS,
        value: result?.docArn[0] || DEFAULT_NULL_REPLACEMENT,
      },
    ];
    setDetailsData(modalData);
    setOpenFlyout(true);
  };

  const viewDetailsHandler = id => {
    setSelectedTableId(id);
    const tableRowInfo = recordsData.find(obj => obj.id === id);
    setModalTitle(tableRowInfo.facility);
    fetchVisitById({
      variables: {
        visitId: id,
      },
    });
  };

  return (
    <Content>
      <BreadcrumbComponent
        breadcrumbData={breadcrumbData}></BreadcrumbComponent>
      <Typography variant="h1">{VISIT.TITLE_TEXT}</Typography>
      <Box sx={boxContainer}>
        <div
          style={{
            display: 'flex',
            position: 'relative',
            justifyContent: 'space-between',
          }}>
          <SearchBar
            sx={{
              width: '50%',
              minWidth: '250px',
              maxWidth: '500px',
              marginTop: '8px',
            }}
            onSearch={onSearch}
            placeholder={VISIT.SEARCH_PLACEHOLDER_TEXT}
            setOffset={setOffset}
          />

          <FilterDropDown {...dateFilterOptions} filterType="Date:" />
          <FilterDropDown
            {...visitTypeFilterOptions}
            filterType="Visit type:"
          />
          <FilterDropDown {...statusFilterOptions} filterType="Status:" />
        </div>
      </Box>
      <Box sx={table}>
        {!fetchAllVisitsCall.loading && !filteredData.length ? (
          <NotFound title={VISIT.TITLE_TEXT} />
        ) : (
          <>
            <ReusableTable
              tableHeading={tableHeading}
              data={filteredData}
              viewDetailsHandler={viewDetailsHandler}
            />
            <div
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                marginTop: 18,
              }}>
              {totalCount > NUMBER_OF_ROWS_PER_PAGE && (
                <PaginationComponent
                  numberOfRowsPerPage={NUMBER_OF_ROWS_PER_PAGE}
                  count={totalCount}
                  onPageClick={onPageClick}
                  page={offset / 10}
                />
              )}
            </div>
          </>
        )}
      </Box>
      <ServiceFlyout
        isOpen={openFlyout}
        handleClose={closeFlyout}
        data={detailsData}
        icon={
          menuItems
            ? getIconFromSubItemsArray(menuItems?.Medical?.subItems, 'Visits')
            : null
        }
        category={VISIT.TITLE_TEXT}
        title={modalTitle}></ServiceFlyout>
      <SimpleBackdrop open={fetchAllVisitsCall.loading || detailsLoading} />
    </Content>
  );
};
